import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit
} from '@angular/core';
import { SwitchingAccountService } from './switching-account.service';

@Component({
  selector: 'ngc-switching-account',
  templateUrl: './switching-account.html'
})
export class SwitchingAccountComponent implements OnInit {
  @Input() bannerDetails: any;
  @Input() isDesktop: any;
  showSwitchPage = false;
  displayBackgroundImage: any;
  displayAccountSwitchingText: any;

  constructor(
    public switchingAccountService: SwitchingAccountService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  /*Listener to handle new Profile Selector Modal*/
  @HostListener('document:click')
  public switchClick() {
    const elementTag = document.querySelector(
      'ngc-switching-account'
    ) as HTMLElement;
    const isTrue =
      elementTag?.getAttribute('newProfileModalSelected') === 'true'
        ? true
        : false;
    const companyName = elementTag?.getAttribute('companyName')
      ? elementTag?.getAttribute('companyName')
      : undefined;
    if (isTrue && this.bannerDetails) {
      this.showSwitchPage = true;
      this.switchingAccountService.accountName = companyName;
      /* if (this.isDesktop) {
        this.displayBackgroundImage =
          this.bannerDetails.imageList[
            Math.floor(Math.random() * this.bannerDetails.imageList.length)
          ].deskImage;
      } else {
        this.displayBackgroundImage =
          this.bannerDetails.imageList[
            Math.floor(Math.random() * this.bannerDetails.imageList.length)
          ].mobileImage;
      } */
      if (
        this.switchingAccountService.businessAccountOptionsLists
          .isOaSmeAccount &&
        this.bannerDetails.acSwitchGenericText
      ) {
        this.displayAccountSwitchingText =
          this.bannerDetails.acSwitchGenericText;
      } else if (this.switchingAccountService.accountName !== undefined) {
        this.displayAccountSwitchingText =
          this.bannerDetails.acSwitchText.replace(
            '{{CNAME}}',
            this.switchingAccountService.accountName
          );
      } else {
        this.displayAccountSwitchingText =
          this.bannerDetails.acSwitchText.replace('{{CNAME}}', '');
      }
      setTimeout(() => {
        elementTag?.setAttribute('newProfileModalSelected', 'false');
        this.showSwitchPage = false;
        window.location.reload();
      }, 2000);
    }
  }

  ngOnInit() {
    if (this.bannerDetails && this.bannerDetails.imageList.length) {
      if (this.isDesktop) {
        this.displayBackgroundImage =
          this.bannerDetails.imageList[
            Math.floor(Math.random() * this.bannerDetails.imageList.length)
          ].deskImage;
      } else {
        this.displayBackgroundImage =
          this.bannerDetails.imageList[
            Math.floor(Math.random() * this.bannerDetails.imageList.length)
          ].mobileImage;
      }
    }
    this.switchingAccountService.displayBody.subscribe((displayBody) => {
      if (displayBody) {
        if (this.isDesktop) {
          this.displayBackgroundImage =
            this.bannerDetails.imageList[
              Math.floor(Math.random() * this.bannerDetails.imageList.length)
            ].deskImage;
        } else {
          this.displayBackgroundImage =
            this.bannerDetails.imageList[
              Math.floor(Math.random() * this.bannerDetails.imageList.length)
            ].mobileImage;
        }
        // added time delay as the method to set account name will call after the switching loaded
        setTimeout(() => {
          if (
            this.switchingAccountService.businessAccountOptionsLists
              .isOaSmeAccount &&
            this.bannerDetails.acSwitchGenericText
          ) {
            this.displayAccountSwitchingText =
              this.bannerDetails.acSwitchGenericText;
          } else if (this.switchingAccountService.accountName !== undefined) {
            this.displayAccountSwitchingText =
              this.bannerDetails.acSwitchText.replace(
                '{{CNAME}}',
                this.switchingAccountService.accountName
              );
          } else {
            this.displayAccountSwitchingText =
              this.bannerDetails.acSwitchText.replace('{{CNAME}}', '');
          }
          this.changeDetectorRef.detectChanges();
          const switchAccount = document.getElementById(
            'switch-account-overlay'
          );
          if (switchAccount) {
            switchAccount.click();
          } // added to fix display update issue
        }, 10);
      }
    });
    this.changeDetectorRef.detectChanges();
  }
}
